<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="contract.product_name+' for '+contract.seller_name+' [Product Contract] - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/contracts">Contracts</router-link>
                    </li>

                    <li class="breadcrumb-item">
                        <router-link :to="`/products/view/${contract.product_id}`">{{ contract.product_name }}</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contract.seller_type == 'Agent'">
                        <router-link :to="`/agents/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item" v-else-if="contract.seller_type == 'Agency'">
                        <router-link :to="`/agencies/view/${contract.seller_id}`">
                            {{ contract.seller_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" v-if="contract.writing_nbr">
                        {{ contract.writing_nbr }}
                    </li>

                </ol>
            </nav>

            <h4 class="page-header">
                {{ contract.product_name }} for {{ contract.seller_name }}
            </h4>

            <div class="mb-3" v-if="canEdit">
                <router-link :to="`/contracts/edit/${contract.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
                <router-link :to="`/contracts/deactivate/${contract.id}`" v-if="contract.is_active === 1" class="btn btn-sm btn-default"><i class="fas fa-power-off"></i> Deactivate</router-link>
                <router-link :to="`/contracts/delete/${contract.id}`" class="btn btn-sm btn-default"><span class="text-danger"><i class="fas fa-trash"></i> Delete</span></router-link>
            </div>

            <div class="row mb-3">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Product:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/products/view/${contract.product_id}`" title="View Product">
                                        {{ contract.product_name }}
                                    </router-link>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Producer:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <template v-if="contract.seller_type == 'Agent'">
                                        <router-link :to="`/agents/view/${contract.seller_id}`">{{ contract.seller_name }}</router-link> (Agent)
                                    </template>
                                    <template  v-else-if="contract.seller_type == 'Agency'">
                                        <router-link :to="`/agencies/view/${contract.seller_id}`">{{ contract.seller_name }}</router-link> (Agency)
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Last Updated At:</div>
                                <div class="col-md-8 col-12">{{ contract.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Last Updated By:</div>
                                <div class="col-md-8 col-12">{{ contract.last_updated_by }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Current Manager Level:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Manager:</div>
                                <div class="col-md-8 col-12">
                                    <template v-if="contract.manager_id && contract.manager_type">
                                        <template v-if="contract.manager_type == 'Agent'">
                                            <router-link :to="`/agents/view/${contract.manager_id}`">{{ contract.manager_name }}</router-link> (Agent)
                                        </template>
                                        <template v-else-if="contract.manager_type == 'Agency'">
                                            <router-link :to="`/agencies/view/${contract.manager_id}`">{{ contract.manager_name }}</router-link> (Agency)
                                        </template>
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Product Level:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ contract.product_level_name }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Date of Change:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span  v-if="contract.date_of_change">{{ contract.date_of_change | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Contract Status:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <label :class="'badge badge-'+contract.contract_status_color">{{ contract.contract_status_name }}</label>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Contract Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <label class="badge badge-success" v-if="contract.is_active === 1">Active</label>
                                    <label class="badge badge-warning" v-else>Inactive</label>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Writing#:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ contract.writing_nbr }}
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Writing# Sent:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <label class="badge badge-success" v-if="contract.is_writing_nbr_sent === 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">
                                    Commission:<br/>
                                    <span class="text-muted">(Legacy Plain Text Value)</span>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <div v-if="contract.commission" class="mb-1">{{ contract.commission }}</div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Advance:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ contract.advance }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            {{ contract.notes ?? '--' }}
                        </div>
                    </div>

                    <div class="card mb-4" v-if="false">
                        <div class="card-header">
                            <strong>Files ({{ files.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <files-list :files="files" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Dates</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Requested:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                   <span v-if="contract.requested_date">{{ contract.requested_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Certification:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                   <span v-if="contract.certification_date">{{ contract.certification_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Credentialing:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="contract.credentialing_date">{{ contract.credentialing_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Sent:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="contract.sent_date">{{ contract.sent_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Termination:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="contract.termination_date">{{ contract.termination_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-m--x mt-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                    <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="tabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                        <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="pt-2">
                <div v-show="curTab === 'levels'">
                    <div class="card">
                        <div class="card-body">
                            <v-client-table :columns="levelColumns" :options="levelOptions" :data="changes">
                                <template slot="id" slot-scope="props">
                                    <router-link :to="`/contracts/manager-level-change/${props.row.id}/delete`" title="Delete This Mgr Level Change" v-if="canDeleteLevelChange(props.row)">
                                        <i class="fa fa-trash text-danger"></i>
                                    </router-link>
                                </template>

                                <template slot="created_at" slot-scope="props">
                                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                </template>

                                <template slot="last_name" slot-scope="props">
                                    {{ props.row.first_name }} {{ props.row.last_name }}
                                </template>

                                <template slot="manager_name" slot-scope="props">
                                    {{ props.row.manager_name }} <span v-if="props.row.manager_npn">, {{ props.row.manager_npn }}</span>
                                </template>

                                <template slot="product_level_name" slot-scope="props">
                                    {{ props.row.product_level_name }}
                                </template>

                                <template slot="date_of_change" slot-scope="props">
                                    <span v-if="props.row.date_of_change">{{ props.row.date_of_change | moment("MM/DD/YYYY") }}</span>
                                </template>
                            </v-client-table>
                        </div>
                    </div>
                </div>

                <div v-show="curTab === 'comments'">
                    <template v-if="$root.hasPermission('comments.create')">
                        <comments-form ref="contractCommentForm" assetType="ProductContract" :assetId="contract.id" @commentCreated="newComment" @commentUpdated="updateComment" @commentCount="((count) => { this.commentCount = count; })"></comments-form>
                        <hr/>
                    </template>

                    <comments-list ref="contractComments" assetType="ProductContract" :assetId="contract.id" :ajaxLoad="true" @editComment="editComment"></comments-list>
                </div>

                <div v-show="curTab === 'downline'">
                    <div class="card">
                        <div class="card-body">
                            <downline-list :contracts="contract.downline" />
                        </div>
                    </div>
                </div>

                <div class="card" v-show="curTab === 'files'">
                    <div class="card-body">
                        <files-list :files="files" />
                    </div>
                </div>

                <div v-show="curTab === 'history'">
                    <div class="card">
                        <div class="card-body">
                            <history-list :record_id="contract.id" record_type="ProductContract" @historyCount="(count) => { this.historyCount = count; }" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                curTab: 'levels',
                id: this.$route.params.id,
                userTimezone: this.$root.timezone,
                now: moment(),
                contract: {},
                files: [],
                changes: [],
                commentCount: 0,
                historyCount: 0,
                downlineLevel: 0,

                //Contract Changes
                levelColumns: ['id', 'created_at', 'last_name', 'manager_name', 'product_level_name', 'date_of_change'],
                levelOptions: {
                    headings: {
                        id: 'Actions',
                        created_at: 'Timestamp',
                        last_name: 'Changed By',
                        manager_name: 'Manager',
                        product_level_name: 'Product Level',
                        date_of_change: 'Date of Change',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'date_of_change',
                    },
                    texts:{
                        filterPlaceholder:"Search History",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('historyCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.asset_type = this.record_type;
                        data.asset_id = this.record_id;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        computed: {
            tabs(){
                return [
                    {key: 'levels', title: 'Mgr Level Changes ('+this.changes.length+')', icon: 'balance-scale'},
                    {key: 'comments', title: 'Comments ('+this.commentCount+')', icon: 'comments'},
                    {key: 'downline', title: 'Downline ('+this.downlineLevel+')', icon: 'sitemap'},
                    {key: 'files', title: 'Files ('+this.files.length+')', icon: 'clone'},
                    {key: 'history', title: 'History ('+this.historyCount+')', icon: 'clock'},
                ];
            },

            tabTitle(){
                //Loop
                for (var i = this.tabs.length - 1; i >= 0; i--)
                {
                    //Check tabl
                    if(this.tabs[i].key === this.curTab)
                    {
                        return '<i class="fa fa-'+this.tabs[i].icon+'"></i> ' + this.tabs[i].title;
                    }
                }

                //Send it
                return '';
            },

            canEdit(){
                //Check Permissions
                return this.$root.hasPermission('contracts.manage');
            },
        },

        methods: {

            getContract(){
                //Send it
                this.$http.get('/contracts/view/' + this.id)
                    .then(response => {
                        //Set the contract
                        this.contract = response.data.contract;
                        this.files = response.data.files;
                        this.downlineLevel = response.data.max_downline_level;
                        this.changes = response.data.changes;
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            editComment(comment){
                //Push into the component
                this.$refs.contractCommentForm.editComment(comment);
            },

            newComment(comment){
                //Push it
                this.$refs.contractComments.addComment(comment);
            },

            updateComment(comment){
                //Update it
                this.$refs.contractComments.updateComment(comment);
            },

            canDeleteLevelChange(change){
                //Check Managment Permission
                if(!this.canEdit)
                {
                    return false;
                }

                //Setup
                var created = moment(change.created_at);

                //Check the Difference
                if(this.now.diff(created, 'days') >= 21)
                {
                    //Cannot Delete
                    return false;
                }

                //Allows
                return true;
            },
        },

        mounted() {
            //get the contract?
            this.getContract();
        }
    }
</script>
